/**
 * CDN 工具函数 - 用于构建时生成 Public 资源完整 URL
 */

const CDN_ORIGIN = process.env.NEXT_PUBLIC_CDN_HOST || '';
const IS_PRODUCTION = process.env.NODE_ENV === 'production';

/**
 * 获取 Public 资源的完整 URL
 * @param path - 相对于 public 目录的路径，如 '/fonts/xxx.woff2'
 * @returns 完整 URL（生产环境走 CDN，开发环境走本地）
 *
 * @example
 * // 开发环境
 * getPublicUrl('/fonts/Montserrat-Bold.woff2')
 * // => '/fonts/Montserrat-Bold.woff2'
 *
 * // 生产环境
 * getPublicUrl('/fonts/Montserrat-Bold.woff2')
 * // => 'https://cdn.example.com/fonts/Montserrat-Bold.woff2'
 */
export function getPublicUrl(path: string): string {
  // 幂等保护：如果传入的已经是完整 URL/特殊协议，则不要再次拼接 CDN
  // 典型场景：某些模块可能二次调用 getPublicUrl，或上游已经传了 CDN 完整地址
  if (
    /^https?:\/\//i.test(path) || // http:// or https://
    /^\/\s*https?:\/\//i.test(path) || // "/https://..."（防御性处理，避免出现双前缀）
    /^\/\//.test(path) || // protocol-relative URL
    /^data:/i.test(path) ||
    /^blob:/i.test(path) ||
    /^javascript:/i.test(path) ||
    /^mailto:/i.test(path) ||
    /^tel:/i.test(path)
  ) {
    return path;
  }

  if (!IS_PRODUCTION || !CDN_ORIGIN) {
    return path;
  }
  const cleanPath = path.replace(/^\/+/, '');
  return `${CDN_ORIGIN}/${cleanPath}`;
}

/**
 * 获取 CDN Origin（用于 preconnect）
 * @returns CDN 域名或空字符串
 *
 * @example
 * getCdnOrigin()
 * // => 'https://cdn.example.com' (生产环境)
 * // => '' (开发环境)
 */
export function getCdnOrigin(): string {
  return IS_PRODUCTION && CDN_ORIGIN ? CDN_ORIGIN : '';
}
